import { colors, gray } from '@kmns-internal/furikake/tokens'
import { Box, TableCell } from '@mui/material'
import { ReportQuestion } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { isAnswered } from 'src/exShared/util/report/isAnswered'
import { hasNoProductMasterData } from 'src/exShared/util/reportResult/hasNoProductMasterData'
import { NoMasterDataMessage } from '../NoMasterDataMessage'
import { buildAnsweredCell } from './buildAnsweredCell'
import { bodyCellSx } from './styles'
import { TableSectionAnsweredCell } from './TableSectionAnsweredCell'
import { TableSectionValueCell } from './TableSectionValueCell'

type Props = {
  question: ReportQuestion
  isTimeDisplayed: boolean
  goPreviewPhoto: (imageUrls: string[], selectedImageIndex: number) => void
}

export const TableSectionBodyCell: FC<Props> = ({
  question,
  isTimeDisplayed,
  goPreviewPhoto,
}) => {
  const { responseType } = question
  // responseType は型上オプショナルだが、未サポート/未設定の質問は描画できないので空セル。
  if (!responseType) {
    return <TableSectionValueCell content={undefined} />
  }

  // 記録時に「該当なし」が選択されたセル。灰色セル + 横線で表す
  if (question.responseAnswer?.noAnswer) {
    return (
      <TableCell sx={{ ...bodyCellSx, p: 0, bgcolor: gray[1] }}>
        <Box sx={{ height: '1px', bgcolor: gray[3] }} />
      </TableCell>
    )
  }

  if (hasNoProductMasterData(question)) {
    return (
      <TableCell sx={bodyCellSx}>
        <NoMasterDataMessage />
      </TableCell>
    )
  }

  if (!isAnswered(question, true)) {
    return (
      <TableSectionValueCell
        content="未回答"
        fontColor={colors.text.disabled}
      />
    )
  }

  return (
    <TableSectionAnsweredCell
      cell={buildAnsweredCell(question, responseType)}
      recordedAt={
        isTimeDisplayed ? question.responseAnswer?.recordedAt : undefined
      }
      goPreviewPhoto={goPreviewPhoto}
    />
  )
}
